// TODO Should be a React component instead of background
// https://insify.atlassian.net/browse/IDEV-3100
// rollup supports it, but storybook doesn't
import * as styles from './Spinner.module.css';

import type { InsifyProps } from '../../types';

type Props = InsifyProps & {
  size?: number | string;
  color?: string;
};

const Spinner: React.VFC<Props> = ({ size = 24, color }) => (
  <div className={styles.Spinner} style={{ width: size, height: size, color }} />
);

export { Spinner };
